export default __webpack_public_path__ + "static/media/closeIcon.bcab3e98.svg";